import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { computeCanonicalHash } from './hash';

// Helper function to derive age from date of birth
export function deriveAgeFromDOB(dobValue) {
  if (!dobValue) return null;

  try {
    let dobDate;
    if (typeof dobValue === 'string') {
      const parts = dobValue.split('-');
      if (parts.length === 2) {
        // YYYY-MM format - assume 15th of month
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]);
        dobDate = new Date(year, month - 1, 15);
      } else if (parts.length === 3) {
        dobDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      } else {
        return null;
      }
    } else {
      return null;
    }

    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }
    return Math.max(age, 0);
  } catch (error) {
    return null;
  }
}

// Helper function to normalize sex from gender
export function normalizeSexFromGender(gender) {
  if (!gender) return null;
  const g = gender.toString().toLowerCase().trim();
  if (g === 'male' || g === 'm') return 'Male';
  if (g === 'female' || g === 'f') return 'Female';
  return 'Other';
}

// Get current user profile for diet stack generation
export async function getCurrentUserProfile(userId) {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (!userDoc.exists()) return null;

    const userData = userDoc.data();

    return {
      age: userData.age || deriveAgeFromDOB(userData.dateOfBirth),
      sex: userData.sex || normalizeSexFromGender(userData.gender),
      lifestage: userData.lifestage || {},
      diet: userData.dietPreference || userData.diet
    };
  } catch (error) {
    console.error('Error getting user profile:', error);
    return null;
  }
}

// Check if diet stack is stale compared to current user profile
export async function checkStackStaleness(stack, userProfile = null) {
  if (!stack || !stack.sourceProfileHash) return false;

  try {
    const user = getAuth().currentUser;
    if (!user) return false;

    // Use provided userProfile or fetch it
    let profile = userProfile;
    if (!profile) {
      profile = await getCurrentUserProfile(user.uid);
    }

    if (!profile) return false;

    // Compute current profile hash
    const currentHash = await computeCanonicalHash({
      age: profile.age,
      sex: profile.sex,
      lifestage: profile.lifestage,
      diet: profile.diet
    });

    // Compare with stored hash
    return currentHash !== stack.sourceProfileHash;
  } catch (error) {
    console.warn('Error checking stack staleness:', error);
    return false;
  }
}









